import OptimizerEditDto from "./OptimizerEditDto";

export class TruncatedNewtonOptimizerEditDto extends OptimizerEditDto   {
    constructor() {
        super();
        /** @type {number} */
        this.offset = null;
        /** @type {number} */
        this.tol = null;
        /** @type {number} */
        this.eta = null;
        /** @type {number} */
        this.stepmx = null
        /** @type {number} */
        this.accuracy = null
        /** @type {number} */
        this.minfev = null
        /** @type {number} */
        this.ftol = null
        /** @type {number} */
        this.xtol = null
        /** @type {number} */
        this.gtol = null
        /** @type {number} */
        this.rescale = null
        /** @type {number} */
        this.maxfun = null
    }

    /**
     * @typedef {Object} _TruncatedNewtonOptimizerEditDtoProps
     * @property {number} offset
     * @property {number} tol
     * @property {number} eta
     * @property {number} stepmx
     * @property {number} accuracy
     * @property {number} minfev
     * @property {number} ftol
     * @property {number} xtol
     * @property {number} gtol
     * @property {number} rescale
     * @property {number} maxfun
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _TruncatedNewtonOptimizerEditDtoProps} TruncatedNewtonOptimizerEditDtoProps
     */
    /**
     * 
     * @param {TruncatedNewtonOptimizerEditDtoProps} props
     * @returns {TruncatedNewtonOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.offset = props.offset;
        this.tol = props.tol;
        this.eta = props.eta;
        this.stepmx = props.stepmx;
        this.accuracy = props.accuracy;
        this.minfev = props.minfev;
        this.ftol = props.ftol;
        this.xtol = props.xtol;
        this.gtol = props.gtol;
        this.rescale = props.rescale;
        this.maxfun = props.maxfun;
        return this;
    }
}

export default TruncatedNewtonOptimizerEditDto;